import './StatusBadge.css';

export type BadgeTone = 'good' | 'warning' | 'attention' | 'neutral' | 'primary';

export function StatusBadge({ children, tone = 'neutral' }: { children: React.ReactNode; tone?: BadgeTone }) {
  return (
    <span className="status-badge" data-tone={tone}>
      {children}
    </span>
  );
}
